export default __webpack_public_path__ + "static/Roobert-SemiBold-656d0b5011580990b28ea6af8c6cd3d8.woff";